import React from 'react';
import {
  ReactQueryConfig,
  ReactQueryConfigProvider as BaseReactQueryConfigProvider,
} from 'react-query';

type Props = {
  config: ReactQueryConfig;
  children?: React.ReactNode;
};

const ReactQueryConfigProvider = BaseReactQueryConfigProvider as React.ComponentType<Props>;

export type { ReactQueryConfig };
export default ReactQueryConfigProvider;
